module.exports = __webpack_public_path__ + "media/dashboard/assets/images/kata/channel-whatsapp-e0e537248332a14221a173a66c59f632.svg";